// src/composables/useTableFilter.ts
import { ref } from 'vue'

const separatedByType = ref(false)
const filterByMe = ref(false)
const savedMode = ref(false)

export function useLibraryTableFilter(defaults: {
  separatedByType?: boolean
  filterByMe?: boolean
  savedMode?: boolean
} = {}) {
  separatedByType.value = defaults.separatedByType ?? false
  filterByMe.value = defaults.filterByMe ?? false
  savedMode.value = defaults.savedMode ?? false
  return {
    separatedByType,
    filterByMe,
    savedMode,
    setSeparatedByType: (value: boolean) => {
      separatedByType.value = value
    },
    setFilterByMe: (value: boolean) => {
      filterByMe.value = value
    },
    setSavedMode: (value: boolean) => {
      savedMode.value = value
    },
  }
}
